export default class User {
  constructor(username, password, token=null, force_new_session=false, notFromLoginPage=false) {
    this.username = username;
    this.password = password;
    this.token = token;
    this.force_new_session = force_new_session;
    this.notFromLoginPage = notFromLoginPage;
  }
}